// Copyright (c) 2022 by Move Closer

import { ComputedRef } from '@vue/composition-api'
import { CanHaveTheme, UseThemeClassProvides } from '../../composables'

/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export interface CustomProgressBarProps extends CanHaveTheme {
  label: string
  maxValue: number
  value: number
  markers?: Array<Marker>
}

export interface Marker {
  label: string
  value: number
}

/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export enum CustomProgressBarTheme {
  Default = 'default',
  Primary = 'primary'
}

/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export type UseCustomProgressBarProvides = {
  themeClass: UseThemeClassProvides
  activeMarker?: ComputedRef<Marker | undefined>
}
